import './App.css';
import React from "react";
import { AppRouter } from './routers/AppRouter';
import UserState from './context/User/UserState';
import ThemeState from './context/theme/ThemeState';
import NotificacionesFinanzasState from './context/NotificacionesFinanzas/NotificacionesFinanzasState';
import 'bootstrap/dist/css/bootstrap.min.css';
function App() {
  return (
    <ThemeState>
      <UserState>
        <NotificacionesFinanzasState>
          <AppRouter />
        </NotificacionesFinanzasState>
      </UserState>
    </ThemeState>
  );
}

export default App;
